/**
 * Quality Matters Section
 * Tasks where quality is critical - don't rush these
 * UX Philosophy: Strategically Transparent, Confidence-Instilling
 */

import React from 'react';
import { Gem, ArrowRight, Clock } from 'lucide-react';

const QualityMattersSection = ({ tasks, onTaskClick }) => {
  if (tasks.length === 0) return null;

  return (
    <div className="space-y-3">
      <div className="flex items-center gap-2">
        <div className="w-6 h-6 bg-purple-500 rounded-full flex items-center justify-center">
          <Gem className="w-4 h-4 text-white" />
        </div>
        <h4 className="text-sm font-bold text-slate-900">Quality Matters Here</h4>
      </div>

      <p className="text-xs text-slate-600">
        Take your time on these - doing them well makes a real difference
      </p>

      <div className="space-y-2">
        {tasks.map(task => (
          <div
            key={task.id}
            className="bg-white rounded-lg p-3 border border-purple-200 hover:border-purple-300 transition-colors cursor-pointer group"
            onClick={() => onTaskClick && onTaskClick(task)}
          >
            <div className="flex items-start justify-between gap-3">
              <div className="flex-1 min-w-0">
                <h5 className="text-sm font-medium text-slate-900 mb-1 group-hover:text-purple-600 transition-colors">
                  {task.title || task.task_name}
                </h5>

                {/* College name if available */}
                {task.college_name && (
                  <p className="text-xs text-slate-600 mb-1">
                    {task.college_name}
                  </p>
                )}

                {/* Support reason - explain WHY quality matters */}
                <p className="text-xs text-slate-700">
                  {task.supportReason}
                </p>

                {/* Time estimate */}
                {task.estimated_hours && (
                  <div className="flex items-center gap-1 text-xs text-slate-600 mt-2">
                    <Clock className="w-3 h-3" />
                    <span>~{task.estimated_hours}h</span>
                  </div>
                )}
              </div>

              {/* Action indicator */}
              <div className="flex-shrink-0">
                <div className="w-8 h-8 bg-purple-50 rounded-full flex items-center justify-center group-hover:bg-purple-100 transition-colors">
                  <ArrowRight className="w-4 h-4 text-purple-600" />
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default QualityMattersSection;
